import { Board } from '../board';
import { BoardSnapshot } from '../board-snapshot';
import { MoveCommand } from '../commands/move-command';
import { GameLogicDepth } from '../game-logic-depth';
import { CardDisclosureStatus, PileType } from '../logic-types';
import { Action, GrantPointsAction } from './action';

export class MoveAction implements Action {
  private move: MoveCommand;
  private board: Board;
  private gameLogicDepth: GameLogicDepth;
  private grantPointsAction: GrantPointsAction;
  private lastSnapshot: BoardSnapshot | undefined;
  private lastCardIndices: number[] = [];

  constructor(
    move: MoveCommand,
    board: Board,
    gameLogicDepth: GameLogicDepth,
    grantPointsAction: GrantPointsAction,
  ) {
    this.move = move;
    this.board = board;
    this.gameLogicDepth = gameLogicDepth;
    this.grantPointsAction = grantPointsAction;
  }

  public saveSnapshot(): void {
    this.lastSnapshot = this.board.boardSnapshot;
    this.board.boardSnapshot = new BoardSnapshot(
      this.lastSnapshot.foundations,
      this.lastSnapshot.tableaus,
      this.lastSnapshot.deck,
      this.lastSnapshot.waste,
    );
  }

  public execute(): void {
    this.saveSnapshot();

    const card = this.board.getCardByCardId(this.move.cardId);
    if (card === undefined) {
      return;
    }

    const originPile = this.board.getPileByCardId(this.move.cardId);
    if (originPile === undefined) {
      return;
    }
    const targetPile = this.board.getPileByPileId(this.move.targetPileId);

    const cardsToMove = originPile.moveCards(card);

    for (const cardToMove of cardsToMove) {
      this.grantPointsAction({
        card: cardToMove,
        pile: targetPile,
      });

      originPile.removeCard(cardToMove);

      this.lastCardIndices.push(cardToMove.index);
      this.gameLogicDepth.updateCardDepth(cardToMove.index);
      targetPile.addCard(cardToMove);
    }

    if (!card.isFaceUp) {
      card.openCard();
      card.setStatusWhenNone(CardDisclosureStatus.Pending);
    }

    if (originPile.hasCards && originPile.type !== PileType.Deck) {
      const lastCard = originPile.lastCard;
      if (lastCard !== undefined) {
        lastCard.openCard();
        lastCard.setStatusWhenNone(CardDisclosureStatus.Pending);
      }
    }
  }

  public undo(): void {
    this.lastCardIndices.forEach((cardIndex) => {
      this.gameLogicDepth.updateCardDepth(cardIndex);
    });
    if (this.lastSnapshot !== undefined) {
      this.board.boardSnapshot = this.lastSnapshot;
    }
  }
}
